/** Page size of the voice picker's infinite scroll. */
export const VOICE_PAGE_SIZE = 30;

/**
 * Arguments of the getVoiceAiVoicesV2 query.
 *
 * Every key is always present. The Hasura action builds the Engagement query
 * string with a Kriti template that reads each argument by name, and a missing
 * key fails the whole request ("Request Transformation Failed") rather than
 * meaning "no filter". Unfiltered values are therefore sent as empty strings,
 * which is what the v1 picker always did.
 */
export const buildVoiceSearchArgs = ({
  language,
  accent,
  audioModel,
  gender,
  search,
  page,
}: {
  language: string;
  accent?: string;
  audioModel: string;
  gender: 'all' | 'male' | 'female';
  search: string;
  page: number;
}) => ({
  provider: 'ElevenLabs',
  language,
  // The language and accent filter; a locale would hide voices verified for
  // the language but tagged with another region.
  locale: '',
  accent: accent || '',
  gender: gender === 'all' ? '' : gender,
  modelId: audioModel,
  search,
  page,
  pageSize: VOICE_PAGE_SIZE,
});

/**
 * ps-select-option rewrites spaces in its value to underscores, so an accent
 * such as "us southern" cannot be an option value as-is. URI-encoding holds no
 * space and round-trips exactly.
 */
export const accentToOptionValue = (accent: string): string =>
  encodeURIComponent(accent);

export const accentFromOptionValue = (value: string): string | undefined => {
  if (!value) return undefined;
  try {
    return decodeURIComponent(value);
  } catch {
    // Only our own encoder writes these values; anything else is no accent.
    return undefined;
  }
};
